export interface MemoryDraft {
  content: string;
  permanent: boolean;
}

export function appendBlankMemoryDraft(drafts: MemoryDraft[]): MemoryDraft[] {
  if (drafts.some((draft) => !draft.content.trim())) return drafts;
  return [...drafts, { content: "", permanent: false }];
}
